import classNames from 'classnames';
import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';

export type BannerType = 'info' | 'warning' | 'error' | 'success';

type Props = {
  type: BannerType;
  title: string;
  message: string;
};

const iconToColorMap = {
  info: <ActionIcon name="info" color="blue600" className="size-6" />,
  warning: (
    <FavouriteIcon name="warning" color="orange600" className="size-6" />
  ),
  error: <FavouriteIcon name="error" color="red600" className="size-6" />,
  success: (
    <FavouriteIcon name="check_circle" color="green600" className="size-6" />
  ),
};

export const Banner = ({ type, title, message }: Props) => {
  return (
    <div
      className={classNames(
        type === 'info' && 'bg-blue-100 text-blue-700',
        type === 'warning' && 'bg-orange-100 text-orange-700',
        type === 'error' && 'bg-red-100 text-red-700',
        type === 'success' && 'bg-green-100 text-green-700',
        'px-4 py-3 rounded relative flex gap-1'
      )}
    >
      {iconToColorMap[type]}
      <div className="flex flex-col">
        <span className="text-body-2-xl font-semibold">{title}</span>
        <span className="text-caption-xl">{message}</span>
      </div>
    </div>
  );
};
